import { useCallback } from 'react';
import { useTranslations, useIsShowTranslationKeys } from 'js/hooks/i18n';

export const useSetTranslations = () => {
    const t = useTranslations();
    const showTranslationKeys = useIsShowTranslationKeys();

    return useCallback((type) => {
        const apiTranslations = window.Communication?.API?.common?.getDefaultTranslations?.();
        const tKeys = apiTranslations?.[type]?.defaultTranslations || [];
        const tkPrefix = 'playtech.mobile.system.';
        const translations = {
            [type]: {}
        };

        for (const tKey in tKeys) {
            const translationKey = tkPrefix + tKey;
            const translatedText = t(translationKey);

            translations[type][tKey] = showTranslationKeys
                ? translationKey
                : translatedText === translationKey
                    ? tKeys[tKey]
                    : translatedText;
        }

        if (type === 'chat') {
            window.Communication?.API?.chat?.addTranslations?.(translations[type]);
        } else {
            window.Communication?.API?.inbox?.addTranslations?.(translations[type]);
        }
    }, [t, showTranslationKeys]);
};
